import React from "react";
import {connect} from 'dva';
import { Row, Col } from 'antd';
import './tempSelect.less'

function TempSelect(props) {

    const { ids, deployConfigInfo, dispatch } = props;
    const templateList = deployConfigInfo.items || [];
    const gutter = window.parent.length > 0 ? 20 : 30;

    const selectTemp = (item, showType) => {
        dispatch({
            type: 'app/getList',
            payload: {
                ...ids,
                templateId: item.templateId,
                showType
            }
        });
    };

    return (
        <div className="select-temp-wrap">
            <Row gutter={gutter}>
                {templateList.map((item, idx) => (
                    <Col className="gutter-row" span={12}  key={idx}  onClick={() => selectTemp(item,1)}>
                        <div className="temp-item">{item.templateName}</div>
                    </Col>
                ))}
            </Row>
        </div>
    )
}

const mapState = state => {
    const {ids, deployConfigInfo} = state.app;
    return {
        ids,
        deployConfigInfo
    };
};

export default connect(mapState)(TempSelect);